// carousel utils.js
export const toggleCustomContainerClass = (tabsWrapper, shouldAdd) => {
    tabsWrapper.classList.toggle("custom-container", shouldAdd);
};

export const getAutoPlayOptions = ({ delay, autoplayEnabled, autoPauseDisabled }) => {
    return autoplayEnabled ? {
        delay,
        pauseOnMouseEnter: autoPauseDisabled
    } : false;
};

export const updateTabState = (tabsChildren, currentIndex) => {
    tabsChildren.forEach((tab, index) => {
        const isActive = index === currentIndex;
        tab.classList.toggle('active', isActive);
        tab.classList.toggle('active-tab', isActive);
    });
};

export const updateArrowVisibility = (currentIndex, tabsSize, selectors) => {
    const leftArrow = document.querySelector(selectors.leftArrow);
    const rightArrow = document.querySelector(selectors.rightArrow);

    leftArrow.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
    rightArrow.style.visibility = currentIndex === tabsSize - 1 ? 'hidden' : 'visible';
};

export const updateTabStateAndArrows = (swiperWrapper, currentIndex, selectors) => {
    const tabsChildren = Array.from(swiperWrapper.children).filter(tab =>
        !tab.classList.contains("arrow") && !tab.classList.contains("swiper-wrapper__arrows-common")
    );

    const tabsSize = tabsChildren.length;

    updateTabState(tabsChildren, currentIndex);
    updateArrowVisibility(currentIndex, tabsSize, selectors);
};
